import React from "react";

interface ProfileSkeletonProps {
  avatarSize?: "xs" | "sm" | "md" | "lg";
}

const ProfileSkeleton: React.FC<ProfileSkeletonProps> = ({ avatarSize = "xs" }) => {
  const avatarSizes = {
    xs: "h-[38px] w-[38px]",
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12",
  };

  return (
    <div className="flex items-center gap-3">
      <div
        className={`relative ${avatarSizes[avatarSize]} flex-shrink-0 overflow-hidden rounded-full bg-gray-200`}
      >
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent" />
      </div>
      <div className="flex-1 space-y-1">
        <div className="relative h-6 w-32 overflow-hidden rounded bg-gray-200">
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent" />
        </div>
        <div className="relative h-5 w-40 overflow-hidden rounded bg-gray-200">
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent [animation-delay:0.2s]" />
        </div>
      </div>
    </div>
  );
};

export default ProfileSkeleton;
